import { ScheduleTrigger } from '@common/sqlIde/scheduleTriggerUtils';
import { OrchestrationScheduledPipelineResponse } from 'frontend/core/src/data/apis/types';

export enum SQLPipelineRunStatus {
  SUCCEEDED = 'SUCCEEDED',
  ERROR = 'ERROR',
  RUNNING = 'RUNNING',
  WARNING = 'WARNING'
}

type ExtractedPipelineInfo = NonNullable<OrchestrationScheduledPipelineResponse['pipelines']>[number];

export type OrchestrationSchedulePipelineInfo = ExtractedPipelineInfo & {
  sensorConfigDetails: ScheduleTrigger[];
};
